import styled from 'styled-components'

import Card from '../../../components/Card'

export const Container = styled(Card)`
	display: grid;
	grid-template-rows: min-content auto;
	grid-template-areas:
		'title edit_icon'
		'endereco endereco';

	> h1 {
		font-size: 19px;
		font-weight: 500;
	}

	> .endereco {
		grid-area: endereco;
		margin-top: 24px;
		display: flex;
		flex-wrap: wrap;
		align-self: flex-start;
		line-height: 24px;
		
		span {
			margin-right: 28px;
		}
	}

	> svg {
		color: #FFF;
		transition: 300ms;

		&:hover {
			opacity: 0.7;
			cursor: pointer;
		}
	}

	.spinner-container {
		grid-area: endereco;
		justify-self: center;
	}

	@media(max-width: 440px) {
		margin: 0;
		border-radius: 0;
	}
`
